module.exports = __webpack_public_path__ + "img/image-hero-blackcup.8f71eb2e.jpg";